import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap'
import Label from "components/general/Label"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { useGetNocs } from 'helpers/commonCodes';
import Noc from 'components/presentation/Noc';
import { isParalympic, CompetitionFromStore } from 'helpers/utils'
import { ALL_URL } from "helpers/utils";
import Form from 'react-bootstrap/Form';


export default function SelectorNoc({ page = "" }) {
    const [textCombo, setTextCombo] = useState();
    let params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page)
    //copy parameters URL to change 
    let paramsURL = { ...params }
    //paramsURL["mirs_noc"] = "";

    const data = useGetNocs(paramsURL)

    const options = data?.nocs?.filter(n=> n.note === 'P')?.map((item) => {
        return (

            <Dropdown.Item key={"Selector-Noc-" + item.code} eventKey={item.code} >
                <ItemNoc nocnode={item} />
            </Dropdown.Item>
        )
    })


    useEffect(() => {
        let lbl = data?.nocs?.find(item => item.code === paramsURL["mirs_noc"])?.description
        if (!lbl) { lbl = <Label data={'LabelAllNocs'} /> }
        setTextCombo(lbl);
    }, [paramsURL["mirs_noc"]]);



    //Go to schedule 
    const handleOnChange = (key) => {
        paramsURL["mirs_noc"] = key
        setParamsUrl(paramsURL);
        setShouldNavigate(true);
    };

    let label = 'LabelAllNocs'
    const competition = CompetitionFromStore();
    if (isParalympic(competition) && label === 'LabelAllNocs') {
        label = 'LabelAllNpcs';
    }

    return (
        <Dropdown onSelect={handleOnChange} id="selectorNoc" className={"selectorContainer dropdownWithGrid"}>
            <Dropdown.Toggle as={CustomToggle} variant="success"  >
                {textCombo}
            </Dropdown.Toggle>

            <Dropdown.Menu as={CustomMenu}>
                <Dropdown.Item key="Selector-Noc-All" eventKey={ALL_URL.ALL_NOC} >
                    <Label data={label} />
                </Dropdown.Item>
                {options}
            </Dropdown.Menu>
        </Dropdown >
    )
};


const ItemNoc = (props) => {
    const { mirs_competition } = useUrlFriendlyToParameters()
    let competition = mirs_competition;
    const [showImage, setShowImage] = useState(true);
    const hideImg = (event) => {
        // this.setState({ showImg: false });
        setShowImage(true);
    };
    props.nocnode.showLongDesc = true;
    return (
        <div className="itemNoc justify-content-left">
            <Noc {...props.nocnode} />
        </div>
    )
};





// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (

    <Dropdown.Toggle variant="success" id="dropdown-basic"
        href=""
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}

    >
        {children}
    </Dropdown.Toggle>

));

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
    ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
        const [value, setValue] = useState('');

        return (
            <div
                ref={ref}
                style={style}
                className={className}
                aria-labelledby={labeledBy}
            >
                <Form.Control
                    autoFocus
                    className="mx-3 my-2 w-auto"
                    placeholder="Type to filter..."
                    onChange={(e) => setValue(e.target.value)}
                    value={value}
                />
                <ul className="list-unstyled">

                    {React.Children.toArray(children).filter(
                        (child) =>
                            !value || child?.props?.children?.props?.nocnode?.description && child?.props?.children?.props?.nocnode?.description?.toLowerCase().includes(value.toLowerCase()),
                    )}
                </ul>
            </div>
        );
    },
);
